import React from 'react'
import { Link } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import "./AllPartners.css"; 
import Filter from '../layout/Filter';  
import SearchIcon from '@mui/icons-material/Search'; 
import BlabData from "../LabData/BlalData";
import { useState } from "react";
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';

export default function Labtest() {

    const [open, setOpen] = useState(false);

  return (
    <>
    <Header/>

      <div className="test_bredcum_sec">
            <div className="container-fluid">
                <div className="test_bredcum">
                    <Link to="/">Home</Link> 
                    <span>&gt;</span>
                    <span className='name_p'>Lab Tests</span>
                </div> 
            </div> 
        </div>

      <div className="filter_and_product_sec">
        <div className="container-fluid">
            <div className="inner_labtest">
                <div className="row">
                    <div className="col-xl-3 col-lg-4">
                        <Filter open={open} setOpen={setOpen} />
                    </div>

                    <div className="col-xl-9 col-lg-8">
                        <div className="right_side_header_test">
                            <h3>Top Booked Tests (43)</h3> 
                            <div className="search_bar_test">
                                <div className="main_serach_bar_test">
                                    <form className="search-form_test">
                                        <input type="search" placeholder="Search Products.........." className="search_input" />
                                        <button type="submit" className="search_btn"> <SearchIcon /> </button>
                                    </form>
                                </div>
                                <div className="filter_btn">
                                    <button className="filter_btn"  onClick={() => setOpen(true)} >
                                        <TuneRoundedIcon/>
                                    </button>
                                </div>
                                <div className="short_by_test">
                                    <select class="form-select" aria-label="Default select example">
                                        <option selected>Open this select menu</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="test_options_price">
                            <div className="row">
                                {BlabData.map((blal)=>(
                                    <div className="col-xl-4 col-lg-6 col-md-6 col-12" key={blal.id}>
                                        <div className="main_box_tests careathome_test">
                                            <div className="img_and_offer_tag">
                                                <img src={blal.image3} alt="" />
                                                <p>{blal.offer}</p>
                                            </div>
                                            <h4>{blal.testname}</h4>
                                            <span>{blal.moretest}</span>
                                            <span>{blal.time}</span>
                                            <div className="price_test_lab">
                                                <div class="price_and_offer">
                                                    <h5>{blal.prices} <span class="off_price_pakages">{blal.oldprices}</span></h5>
                                                    <span class="offer_pakages">{blal.offer}</span>
                                                </div>
                                                <div className="add_btn_test">
                                                    <a href="#">{blal.addbtn}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                 ))}  
                            </div>
                        </div>
    
                    </div>
                </div>
            </div>
        </div>
      </div>
    <Footer/>
    </>
  )
}
